import axios from 'axios'
import {
  Toast
} from 'vant';
import Router from '@/router/index'
// create an axios instance
var url = ""
if (process.env.NODE_ENV === "development") {
  url = '/api'
} else {
  url = '/public/index.php'
}
const service = axios.create({    
  baseURL: url, // url = base url + request url
  // http://gc.hnzhanfeng.com
  // /public/index.php
  // http://192.168.0.55/public/index.php
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})
service.interceptors.request.use(
  config => {
    config.headers['token'] = localStorage.getItem('userToken') || '';
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response.data;
    //  if(response.config.url=='/api/api/Pet/getOrderState'||response.config.url=='/api/api/Pet/addOrder'){
    //   return res;
    // }
    if (res.errcode === 0) {
      if (res.msg !== '请求成功~' && res.msg !== '请求成功' && res.msg !== '' && res.msg !== 'success') {
        Toast({
          message: res.msg,
          duration: 1000
        });
      }
    if(response.config.url=='/public/index.php/api/Pet/getOrderState'||response.config.url=='/public/index.php/api/Pet/addOrder'){
       return res;
     }
      return res.res
    } else if (res.errcode == 4001) {
      localStorage.removeItem('userToken');
      Router.push({
        path: '/login'
      })
    } else {
      Toast({
        message: res.msg,
        duration: 1000
      });
      return Promise.reject()
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js